import { useGetProviderIconUrl } from '../hooks/use-get-provider-icon-url'
import type { BaseIconProps } from './base-provider-icon'
import { BaseProviderIcon } from './base-provider-icon'

/**
 * The TMS App icon component
 */
export const TMSAppIcon = ({ size }: BaseIconProps) => {
  const iconUrl = useGetProviderIconUrl('api', 'icon')

  return <BaseProviderIcon size={size} src={iconUrl} label="tms-app-icon" />
}
